<template><AccessStateView kind="AssignmentPending" /></template>
<script setup>
import AccessStateView from "./AccessStateView.vue";
</script>
